export const API = 'https://admin.platformonline.uk/wp-json/wp/v2';
export const ACF_API = 'https://admin.platformonline.uk/wp-json/acf/v3';
